import React from "react";
import { useAuth } from "../../context/AuthContext";
import AdminLogin from "../admin/AdminLogin";
import { Box, Spinner } from "@cloudscape-design/components";

export default function AdminProtectedRoute({ children }) {
  const { isAdminAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <Box textAlign="center" padding="xxl">
        <Spinner size="large" />
      </Box>
    );
  }

  if (!isAdminAuthenticated) {
    return <AdminLogin />;
  }

  return children;
}
